import axios from 'axios';
import { buildPath } from './Base.api';

export function* sendContactForm(data) {
    const url = buildPath('/contact');
    return yield axios.post(url, data);
}
